import {
    CLEAR_ALL,
    GET_SANDBOX_STATE_REQUEST,
    GET_SANDBOX_STATE_SUCCESS,
    GET_SANDBOX_STATE_ERROR,
    CREATE_SANDBOX_REQUEST,
    CREATE_SANDBOX_SUCCESS,
    CREATE_SANDBOX_ERROR,
    GET_SANDBOX_REQUEST,
    GET_SANDBOX_SUCCESS,
    GET_SANDBOX_ERROR,
} from 'constants/ActionTypes';
import { SANDBOX_NO_CREATED, SANDBOX_PENDING } from 'constants/App';

const initialState = {
    status: SANDBOX_NO_CREATED,
    loading: true,
    sandbox: {},
    loadingGet: false,
    errorGet: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_SANDBOX_STATE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_SANDBOX_STATE_SUCCESS:
            // const num = Math.floor(Math.random() * 2) + 1;
            return {
                ...state,
                loading: false,
                status: action.payload.state || SANDBOX_NO_CREATED,
                // status: 'creation denied',
                // status: (num === 1) ? SANDBOX_PENDING : SANDBOX_NO_CREATED,
                sandbox: {},
            };
        case GET_SANDBOX_STATE_ERROR:
            return {
                ...state,
                loading: false,
                status: SANDBOX_NO_CREATED,
            };
        case CREATE_SANDBOX_REQUEST:
        case CREATE_SANDBOX_SUCCESS:
            return {
                ...state,
                status: SANDBOX_PENDING,
                sandbox: {},
            };
        case CREATE_SANDBOX_ERROR:
            return {
                ...state,
                sandbox: {},
                status: SANDBOX_NO_CREATED,
            };
        case GET_SANDBOX_REQUEST:
            return {
                ...state,
                loadingGet: true,
                errorGet: false,
                sandbox: {},
            };
        case GET_SANDBOX_SUCCESS:
            return {
                ...state,
                loadingGet: false,
                errorGet: false,
                sandbox: action.payload,
            };
        case GET_SANDBOX_ERROR:
            return {
                ...state,
                loadingGet: false,
                errorGet: true,
                sandbox: {},
            };
        case CLEAR_ALL:
            return initialState;
        default:
            return {
                ...state,
            };
    }
}
